/* KLAKK · comportements (spec §6). Vanilla, sans dépendance, compatible éditeur de thème. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    var f = window.KK_MONEY_FORMAT || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
            .replace(/\{\{\s*amount\s*\}\}/, withCommas)
            .replace(/<[^>]*>/g, '');
  };

  /* ---------- Apparition au défilement ---------- */
  var io = null;
  function initReveal(root) {
    var els = $$('.kk-reveal:not(.in)', root);
    if (!document.documentElement.classList.contains('kk-js') || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    if (!io) io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Bandeau défilant ---------- */
  function initBar(root) {
    $$('[data-kk-bar]', root).forEach(function (m) {
      if (m.dataset.kkInit) return; m.dataset.kkInit = '1';
      m.innerHTML += m.innerHTML;
    });
  }

  /* ---------- Séquence Load / Rack / Fire ---------- */
  function initSeq(root) {
    $$('[data-kk-seq]', root).forEach(function (seq) {
      if (seq.dataset.kkInit) return; seq.dataset.kkInit = '1';
      var steps = $$('.kk-step', seq), imgs = $$('[data-kk-seq-img]', seq);
      var dur = parseFloat(seq.dataset.kkDur || '3.6') * 1000, t = null, i = 0;
      if (!steps.length) return;
      function go(n) {
        i = (n + steps.length) % steps.length;
        steps.forEach(function (s, j) { s.classList.remove('on'); s.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        void seq.offsetWidth; // relance l'animation de la barre
        steps[i].classList.add('on');
        imgs.forEach(function (m, j) { m.classList.toggle('on', j === i); });
        clearTimeout(t); t = setTimeout(function () { go(i + 1); }, dur);
      }
      steps.forEach(function (s, j) { s.addEventListener('click', function () { go(j); }); });
      go(0);
    });
  }

  /* ---------- Avis : voir plus / voir moins ---------- */
  function initReviews(root) {
    $$('[data-kk-reviews]', root).forEach(function (box) {
      if (box.dataset.kkInit) return; box.dataset.kkInit = '1';
      var cards = $$('.kk-rev', box), btn = $('[data-kk-more]', box);
      var first = window.matchMedia('(min-width:760px)').matches ? 6 : 3, shown = first;
      function render() {
        cards.forEach(function (c, j) { c.hidden = j >= shown; });
        if (!btn) return;
        var left = cards.length - shown;
        btn.parentNode.hidden = cards.length <= first;
        btn.textContent = left > 0 ? (btn.dataset.more || 'Show more reviews') + ' · ' + left + ' more' : (btn.dataset.less || 'Show less');
      }
      if (btn) btn.addEventListener('click', function () {
        if (shown < cards.length) { shown += 6; } else { shown = first; box.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        render();
      });
      render();
    });
  }

  /* ---------- Date d'expédition : aujourd'hui + N jours ouvrés ---------- */
  function initShipDate(root) {
    $$('[data-kk-shipdate]', root).forEach(function (el) {
      var n = parseInt(el.dataset.kkShipdate || '2', 10), d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    });
  }

  /* ---------- Fiche produit ---------- */
  function initPdp(root) {
    $$('[data-kk-pdp]', root).forEach(function (pdp) {
      if (pdp.dataset.kkInit) return; pdp.dataset.kkInit = '1';
      var dataEl = $('[data-kk-product]', pdp);
      if (!dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var optIdx = parseInt(pdp.dataset.kkOptIndex || '0', 10);
      var form = $('form[action*="/cart/add"]', pdp);
      var idInput = form ? $('[name="id"]', form) : null;
      var current = product.variants.find(function (v) { return String(v.id) === String(idInput && idInput.value); }) || product.variants[0];

      /* Galerie : points mobiles */
      var track = $('.kk-gal__track', pdp), dots = $$('.kk-gdots i', pdp);
      if (track && dots.length) track.addEventListener('scroll', function () {
        var k = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('on', j === k); });
      }, { passive: true });

      /* Prix */
      function addons() { return $$('[data-kk-addon] input:checked', pdp); }
      function renderPrice() {
        var now = current.price, was = current.compare_at_price || 0;
        addons().forEach(function (a) { now += +a.dataset.price; was += +(a.dataset.compare || a.dataset.price); });
        if (!current.compare_at_price) was = 0;
        var save = was > now ? Math.round((1 - now / was) * 100) : 0;
        $$('[data-kk-now]').forEach(function (e) { e.textContent = money(now); });
        $$('[data-kk-was]').forEach(function (e) { e.textContent = was ? money(was) : ''; e.hidden = !was; });
        $$('[data-kk-save]').forEach(function (e) { e.hidden = !save; var n = $('[data-kk-save-n]', e); if (n) n.textContent = save; });
        $$('[data-kk-atc-price]').forEach(function (e) { e.textContent = money(now); });
      }

      /* Coloris */
      var cwBtns = $$('[data-kk-cw]', pdp), cwName = $$('[data-kk-cw-name]', pdp), firstImg = $('[data-kk-gal-first] img', pdp);
      function selectValue(val, push) {
        var target = product.variants.find(function (v) {
          return v.options[optIdx] === val && v.options.every(function (o, k) { return k === optIdx || o === current.options[k]; });
        }) || product.variants.find(function (v) { return v.options[optIdx] === val; });
        if (!target) return;
        current = target;
        if (idInput) { idInput.value = target.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        cwBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.kkCw === val ? 'true' : 'false'); });
        cwName.forEach(function (e) { e.textContent = val; });
        var src = (target.featured_media && target.featured_media.preview_image && target.featured_media.preview_image.src) || (target.featured_image && target.featured_image.src);
        if (firstImg && src) {
          firstImg.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
          firstImg.removeAttribute('srcset');
        }
        var atc = $('[data-kk-atc]', pdp);
        if (atc) atc.setAttribute('aria-disabled', target.available ? 'false' : 'true');
        renderPrice();
        if (push && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', target.id); u.searchParams.delete('cw');
          window.history.replaceState({}, '', u.toString());
        }
        document.dispatchEvent(new CustomEvent('kk:variant', { detail: { variant: target } }));
      }
      cwBtns.forEach(function (b) { b.addEventListener('click', function () { selectValue(b.dataset.kkCw, true); }); });
      var cw = new URLSearchParams(window.location.search).get('cw');
      if (cw) {
        var hit = cwBtns.find(function (b) { return b.dataset.kkCw.toLowerCase() === cw.toLowerCase(); });
        if (hit) selectValue(hit.dataset.kkCw, false);
      }

      $$('[data-kk-addon] input', pdp).forEach(function (i) { i.addEventListener('change', renderPrice); });
      renderPrice();

      /* Après l'ajout du produit principal : ajoute les add-ons cochés, puis rafraîchit le tiroir panier */
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (!ev || ev.source !== 'product-form') return;
          var btn = $('[data-kk-atc]', pdp);
          if (btn) {
            btn.classList.add('is-added');
            var lab = $('[data-kk-atc-label]', btn), old = lab ? lab.innerHTML : '';
            if (lab) lab.innerHTML = btn.dataset.added || 'Added ✓';
            setTimeout(function () { btn.classList.remove('is-added'); if (lab) lab.innerHTML = old; }, 1600);
          }
          var items = addons().map(function (a) { return { id: +a.value, quantity: 1 }; });
          if (!items.length) return;
          var drawer = document.querySelector('cart-drawer');
          var body = { items: items };
          if (drawer && drawer.getSectionsToRender) {
            body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          }
          fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res && res.sections && drawer && drawer.renderContents) drawer.renderContents(res);
          }).catch(function (e) { console.error(e); });
        });
      }

      /* Barre collante mobile */
      var bar = $('[data-kk-sticky]', pdp), buy = $('#buy', pdp);
      if (bar && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(buy);
        var sb = $('[data-kk-sticky-btn]', bar);
        if (sb) sb.addEventListener('click', function () {
          var b = $('[data-kk-atc]', pdp);
          if (b) b.click();
        });
      }
    });
  }

  function initAll(root) {
    root = root || document;
    initBar(root); initReveal(root); initSeq(root); initReviews(root); initShipDate(root); initPdp(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
